import { render, staticRenderFns } from "./ArticleListPage.vue?vue&type=template&id=39a99dee&scoped=true&"
import script from "./ArticleListPage.vue?vue&type=script&lang=js&"
export * from "./ArticleListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a99dee",
  null
  
)

export default component.exports